import { render, staticRenderFns } from "./ProjectsTableList.vue?vue&type=template&id=c46c7e74&"
import script from "./ProjectsTableList.vue?vue&type=script&lang=js&"
export * from "./ProjectsTableList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsTableList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports